import { useState } from "react";
import { useApi, Status } from "./useApi";

export const RegistrosView = ({ F, onReg }) => {
  const [q, setQ] = useState("");
  const [plantilla, setPlantilla] = useState("");
  const { data: tpl } = useApi("/plantillas");
  const { data, error } = useApi("/registros", { q, plantilla, deporte: F.deporte, periodo: F.periodo });
  return (
    <div data-testid="registros-view">
      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 10 }} className="fgrid2">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar en todos los registros…" aria-label="Buscar registros" data-testid="registros-search-input" />
        <select value={plantilla} onChange={(e) => setPlantilla(e.target.value)} aria-label="Plantilla" data-testid="registros-plantilla-select">
          <option value="">Todas las plantillas</option>
          {Object.entries(tpl || {}).map(([k, t]) => <option key={k} value={k}>{t.n}</option>)}
        </select>
      </div>
      <Status data={data} error={error} />
      {data && (
        <>
          <p className="note" data-testid="registros-count">{data.length} registros</p>
          <div className="wrapx">
            <table className="tbl" data-testid="registros-table">
              <thead><tr><th>Fecha</th><th>Plantilla</th><th>Registro</th><th>Deporte</th><th>Completo</th></tr></thead>
              <tbody>
                {data.slice(0, 500).map((r) => (
                  <tr key={r.id} className="clk" onClick={() => onReg(r.id)} data-testid={`registro-row-${r.id}`}>
                    <td style={{ whiteSpace: "nowrap" }}>{r.fecha}</td>
                    <td><span className="badge">{r.plantilla}</span></td>
                    <td>{r.titulo}{r.parcial && <> <span className="badge y">texto parcial</span></>}{r.origen !== "Drive" && <> <span className="badge g">nuevo</span></>}{r.prioridad && <> <span className="badge r">prioridad</span></>}</td>
                    <td>{r.deporte}</td>
                    <td data-testid={`registro-completo-${r.id}`}>{r.completo}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {data.length > 500 && <p className="note">Mostrando los 500 más recientes. Usa el buscador o los filtros para encontrar otros.</p>}
        </>
      )}
    </div>
  );
};

export const NuevoView = ({ onNew }) => {
  const { data, error } = useApi("/plantillas");
  if (!data) return <Status data={data} error={error} />;
  return (
    <div className="panel" data-testid="nuevo-view">
      <h4>Crear un formulario nuevo</h4>
      <p className="note">Cada plantilla reproduce el formato del Drive. Lo que guardes alimenta el Panel.</p>
      <div className="chips">
        {Object.entries(data).map(([k, t]) => <button key={k} className="chip" onClick={() => onNew(k)} data-testid={`nuevo-${k}-btn`}>{t.n}</button>)}
      </div>
    </div>
  );
};
